import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-655209e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M277.817 0.000856054H327L323.098 16.9102L312.606 23.2115L321.16 34.3627L312.375 41.5004L302.836 29.0792L285.633 39.4102H268.724C271.755 26.274 274.786 13.1379 277.818 0.000856054H277.817ZM444.254 29.3144H481.45L479.12 39.4094H429.958C432.011 30.5168 434.063 21.6208 436.116 12.7291L451.782 0.000856054H488.216L485.886 10.0967H453.633L448.019 14.6576C453.727 14.661 459.436 14.6644 465.145 14.6679L462.816 24.7629L449.869 24.7526L444.255 29.3135L444.254 29.3144ZM314.292 11.3214L314.575 10.0959H285.584L281.149 29.3144H283.783L314.293 11.3214H314.292ZM67.7419 22.5008L72.9836 29.3144H95.1603L98.0227 16.9094L92.781 10.0959H70.6043L67.7419 22.5008V22.5008ZM66.4728 39.4094L56.6822 26.6811L62.8389 0.000856054H99.2918L109.083 12.7291L102.926 39.4094H66.4728V39.4094ZM432.141 10.0959H393.074L390.211 22.5008L395.453 29.3144H427.705L425.375 39.4102H388.942L379.15 26.682L385.308 0.00171211H434.47L432.141 10.0967V10.0959ZM41.3405 29.6393H19.1638L7.13766 39.4102H0L9.09441 0.000856054H19.1903L14.0726 22.1775L17.3148 19.5435H43.6709L48.1814 0.000856054H58.2764C55.2446 13.1379 52.2137 26.2732 49.1828 39.4102H39.0869C39.8387 36.1527 40.5896 32.8969 41.3413 29.6393H41.3405ZM336.542 22.1775L339.783 19.5435H366.16L368.34 10.0967H346.144L337.758 16.9102L336.542 22.1775H336.542ZM371.651 39.4102H361.556L363.811 29.6393H341.634L329.608 39.4102H322.47L328.627 12.7299L344.293 0.00171211H380.727C377.691 13.1558 374.687 26.2569 371.652 39.4111L371.651 39.4102ZM200.483 39.4102L205.513 16.9102L200.272 10.0967H178.075L171.31 39.4102H161.254L170.349 0.000856054H204.692H206.783L216.574 12.7291L210.579 39.4094H200.484L200.483 39.4102ZM126.679 0.000856054L121.486 22.5008L126.728 29.3144H148.924L155.689 0.000856054H165.745L156.65 39.4102H120.216L110.426 26.682L116.584 0.00171211H126.679V0.000856054ZM227.385 29.3144H256.396L259.259 16.9094L254.017 10.0959H231.841C230.359 16.5143 228.864 22.9079 227.386 29.3144H227.385ZM214.999 39.4094C218.033 26.2646 221.038 13.1567 224.074 0H260.527L270.319 12.7282L264.161 39.4085H214.998L214.999 39.4094Z",
  fill: "black"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" MY PROFILE ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("My balance")
const _hoisted_7 = { style: {"display":"flex","gap":".5rem","align-items":"center"} }
const _hoisted_8 = { style: {"display":"flex","gap":".5rem","align-items":"center"} }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("My address")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Current network")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Exchange rates provided by ")
const _hoisted_12 = {
  href: "https://www.coingecko.com/",
  target: "_blank"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode("CoinGecko")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Connect ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Please install Metamask or some other compatible web3 browser wallet. ")
const _hoisted_16 = { class: "mobile-menu-extra" }
const _hoisted_17 = { style: {"margin-left":"0.5rem"} }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Exchange rates provided by ")
const _hoisted_19 = {
  href: "https://www.coingecko.com/",
  target: "_blank"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode("CoinGecko")
const _hoisted_21 = { style: {"margin-left":"0.5rem"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_el = _resolveComponent("n-el")!
  const _component_n_text = _resolveComponent("n-text")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_bars = _resolveComponent("bars")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_user = _resolveComponent("user")!
  const _component_global_currency_icon = _resolveComponent("global-currency-icon")!
  const _component_global_network_icon = _resolveComponent("global-network-icon")!
  const _component_n_divider = _resolveComponent("n-divider")!
  const _component_n_popover = _resolveComponent("n-popover")!
  const _component_network_modal = _resolveComponent("network-modal")!
  const _component_n_modal = _resolveComponent("n-modal")!
  const _component_n_card = _resolveComponent("n-card")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_n_el, { class: "logo-container" }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("svg", {
              width: "200",
              height: "42",
              viewBox: "0 0 489 16.97",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeRoute('Racing'))),
              style: {"cursor":"pointer"}
            }, _hoisted_4))
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_n_space, {
        class: "navigation-options",
        justify: "center",
        style: {"gap":"3rem"}
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigationOptions, (navOp, i) => {
            return (_openBlock(), _createBlock(_component_n_button, {
              class: "thick-text",
              key: i,
              text: "",
              size: "large",
              onClick: ($event: any) => (_ctx.changeRoute(navOp.routeName))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_text, {
                  strong: _ctx.router.currentRoute.value.name === navOp.routeName ? true : false,
                  type: _ctx.router.currentRoute.value.name === navOp.routeName ? 'primary' : 'default',
                  class: _normalizeClass(_ctx.router.currentRoute.value.name === navOp.routeName ? 'text-shiny' : '')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(navOp.title), 1)
                  ]),
                  _: 2
                }, 1032, ["strong", "type", "class"])
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ]),
        _: 1
      }),
      (_ctx.ethReactive.initialized)
        ? (_openBlock(), _createBlock(_component_n_space, {
            key: 0,
            size: "large",
            justify: "right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_button, {
                circle: "",
                class: "mobile-menu-button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showNavMenu = true))
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_n_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_bars)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_n_popover, {
                trigger: "click",
                placement: "bottom-end"
              }, {
                trigger: _withCtx(() => [
                  _createVNode(_component_n_button, {
                    text: "",
                    class: "navigation-info",
                    size: "large"
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_n_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_user)
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_n_space, { vertical: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_text, { depth: "3" }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_n_text, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_global_currency_icon, {
                              name: _ctx.eth.reactive.value.network.nativeCurrency?.symbol
                            }, null, 8, ["name"]),
                            _createElementVNode("span", null, _toDisplayString(_ctx.formatNumber(_ctx.ethReactive.balance)), 1),
                            (_ctx.exchangeRatesAvailable)
                              ? (_openBlock(), _createBlock(_component_n_text, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_8, [
                                      _createVNode(_component_global_currency_icon, { name: "USD" }),
                                      _createTextVNode(" " + _toDisplayString(_ctx.convertToUSD(_ctx.formatNumber(_ctx.ethReactive.balance), true)), 1)
                                    ])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_n_text, { depth: "3" }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_n_text, null, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.ethReactive.unstoppableDomain ? _ctx.ethReactive.unstoppableDomain : _ctx.formatHexAddress(_ctx.ethReactive.userAddress)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_n_text, { depth: "3" }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_n_button, {
                        style: _normalizeStyle('color: ' + _ctx.ethReactive.network.color),
                        text: "",
                        size: "large",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showNetworkModal = true))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_n_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_global_network_icon, {
                                name: _ctx.ethReactive.network.name
                              }, null, 8, ["name"])
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.ethReactive.network.capitalizedName()), 1)
                        ]),
                        _: 1
                      }, 8, ["style"]),
                      _createVNode(_component_n_divider, { style: {"margin":"0","background":"rgba(0, 0, 0, .4)"} }),
                      _createVNode(_component_n_text, {
                        depth: "3",
                        size: "small",
                        style: {"font-size":".75rem"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11,
                          _createElementVNode("a", _hoisted_12, [
                            _createVNode(_component_n_text, { type: "info" }, {
                              default: _withCtx(() => [
                                _hoisted_13
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_n_space, {
            key: 1,
            justify: "right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_button, {
                type: "primary",
                size: "large",
                onClick: _ctx.eth.connect
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }))
    ]),
    _createVNode(_component_n_modal, {
      show: _ctx.showNetworkModal,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showNetworkModal) = $event)),
      style: {"width":"max-content"},
      "mask-closable": !(_ctx.ethReactive?.network?.id == 0)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_network_modal, {
          class: "modal",
          onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showNetworkModal=false))
        })
      ]),
      _: 1
    }, 8, ["show", "mask-closable"]),
    _createVNode(_component_n_modal, {
      show: _ctx.showWalletModal,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showWalletModal) = $event)),
      class: "modal",
      style: {"width":"max-content"},
      "mask-closable": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_card, null, {
          default: _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_n_modal, {
      style: {"background":"rgba(0, 0, 0, .5)","backdrop-filter":"blur(10px)"},
      show: _ctx.showNavMenu,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showNavMenu) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_card, {
          bordered: false,
          class: "mobile-nav-menu"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_n_space, { vertical: "" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigationOptions, (navOp, i) => {
                  return (_openBlock(), _createBlock(_component_n_button, {
                    key: i,
                    text: "",
                    onClick: ($event: any) => (_ctx.changeRoute(navOp.routeName)),
                    style: {"margin-bottom":"0"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h2", null, _toDisplayString(navOp.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128)),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_n_divider),
                  _createVNode(_component_n_space, { vertical: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_button, {
                        style: _normalizeStyle('color: ' + _ctx.ethReactive.network.color),
                        text: "",
                        size: "large",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showNetworkModal = true))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_n_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_global_network_icon, {
                                name: _ctx.ethReactive.network.name
                              }, null, 8, ["name"])
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.ethReactive.network.capitalizedName()), 1)
                        ]),
                        _: 1
                      }, 8, ["style"]),
                      _createVNode(_component_n_tooltip, {
                        trigger: "hover",
                        placement: "bottom-end",
                        disabled: !_ctx.exchangeRatesAvailable
                      }, {
                        trigger: _withCtx(() => [
                          _createVNode(_component_n_button, {
                            text: "",
                            size: "large"
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_n_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_global_currency_icon, {
                                    name: _ctx.eth.reactive.value.network.nativeCurrency?.symbol
                                  }, null, 8, ["name"])
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formatNumber(_ctx.ethReactive.balance)), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_global_currency_icon, {
                            name: "USD",
                            size: 12
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.convertToUSD(_ctx.formatNumber(_ctx.ethReactive.balance), true)) + " ", 1),
                          _createVNode(_component_n_divider, { style: {"margin":"0"} }),
                          _createVNode(_component_n_text, {
                            size: "small",
                            style: {"font-size":".75rem"}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_18,
                              _createElementVNode("a", _hoisted_19, [
                                _createVNode(_component_n_text, { type: "info" }, {
                                  default: _withCtx(() => [
                                    _hoisted_20
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_n_button, {
                        text: "",
                        size: "large"
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_n_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_user)
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.ethReactive.unstoppableDomain ? _ctx.ethReactive.unstoppableDomain : _ctx.formatHexAddress(_ctx.ethReactive.userAddress)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}